import { useCallback } from "react";
import { useMutation } from "@apollo/client";

import { useAuth } from "modules/providers/auth-provider";
import {
  EditStarredIdListMutation,
  EditStarredIdListMutationVariables,
} from "gql/graphql";
import EDIT_STARRED_ID_LIST_MUTATION from "modules/contacts/networking/edit-starred-id-list-mutation";

const useToggleStarredIdList = () => {
  const { me } = useAuth();
  const [editStarredIdListMutationAPI] = useMutation<
    EditStarredIdListMutation,
    EditStarredIdListMutationVariables
  >(EDIT_STARRED_ID_LIST_MUTATION);

  return useCallback(
    (id: string) => {
      if (!me) {
        return;
      }

      const newStarredIdList = me.starredIdList.includes(id)
        ? [...me.starredIdList.filter((obj) => obj !== id)]
        : [...me.starredIdList, id];

      editStarredIdListMutationAPI({
        variables: {
          starredIdList: newStarredIdList,
        },
        optimisticResponse: {
          editMe: {
            __typename: "User",
            id: me.id,
            starredIdList: newStarredIdList,
          },
        },
      });
    },
    [editStarredIdListMutationAPI, me],
  );
};

export default useToggleStarredIdList;
